import React from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Button } from '../..';

type Props = ButtonProps & {
  withHotkey?: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    '&:hover': {
      backgroundColor: palette.buttonAction.background,
    },
  },
  disabled: palette.disabledButton,
}), { name: 'submit' });

const FormNextStep = ({
  children,
  disabled,
  withHotkey,
  classes,
  ...props
}: Props) => {
  const styles = useStyles();

  return (
    <Button
      disabled={disabled}
      type="button"
      classes={{
        ...styles,
        ...classes,
      }}

      {...props}
    >
      {children}
    </Button>
  );
};

export default FormNextStep;
